import React from 'react';
import NoticeType from './NoticeType';
import { Container } from 'react-bootstrap';
const Careers = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return (
        <Container className='py-3 py-md-5'>
            <NoticeType ntId={2} spId={233} cardHeading={ appLanguage === 'hi' ? "विश्वविद्यालय में करियर/भर्ती" : "Careers / Recruitment At University"} />
        </Container>
    );
}
export default Careers;